import './HvacFormGroupDeleteConfirmationModal.scss';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { Modal } from 'src/modules/common/components/Modal';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import { WarningIcon } from 'src/modules/common/icons/WarningIcon';
import { BodyText } from 'src/modules/common/typography/BodyText';
import { LeadText } from 'src/modules/common/typography/LeadText';

type Props = {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onSubmit: () => void;
};

export const HvacFormGroupDeleteConfirmationModal = ({ isOpen, onClose, onSubmit }: Props): React.ReactElement => (
  <Modal size="sm" opened={isOpen} handleClose={onClose}>
    <ModalHeader
      danger={true}
      label={<FormattedMessage id="hvac/form/group/deleteConfirmation/header/title"/>}
      handleClose={onClose}
    />

    <ModalBody danger={true}>
      <div className="bp-hvac-form-group-delete-confirmation-modal">
        <div className="bp-hvac-form-area-reset-confirmation-modal__icon">
          <WarningIcon/>
        </div>

        <LeadText>
          <FormattedMessage id="hvac/form/group/deleteConfirmation/body/title"/>
        </LeadText>

        <BodyText>
          <FormattedMessage id="hvac/form/group/deleteConfirmation/body/description"/>
        </BodyText>
      </div>
    </ModalBody>

    <ModalFooter>
      <Button
        fullWidth={true}
        kind="secondary"
        autoFocus={true}
        onClick={onClose}
      >
        <FormattedMessage id="hvac/form/group/deleteConfirmation/footer/cancel"/>
      </Button>

      <Button
        fullWidth={true}
        kind="danger"
        onClick={onSubmit}
      >
        <FormattedMessage id="hvac/form/group/deleteConfirmation/footer/submit"/>
      </Button>
    </ModalFooter>
  </Modal>
);
